import List from '../../components/List/List';
import { categories } from '../../utils/cardInfo';

const JobsPage = () => {
  return (
    <List
      category={'jobs'}
      heading={'Jobs'}
      cardHeader={categories.jobs.cardHeader}
      icons={categories.jobs.icons}
      dotColor={categories.jobs.dotColor}
    />
  );
};

export default JobsPage;
